import { ActionTree } from 'vuex';
import axiosInstance from '@/services/api/http.service.js';
import getEnv from '@/utils/env';
import { State } from '@/store/modules/alertV2/extTagGrouping/extTagGrouping.store';

const API_URL =
  getEnv('VUE_APP_ALERT_TAG_GROUP_HOST') ||
  process.env.VUE_APP_ALERT_TAG_GROUP_HOST ||
  'http://localhost:63253';

const http = new axiosInstance({ auth: true });

const actions: ActionTree<State, any> = {
  async getExtagGroupTableData(context, params) {
    try {
      const response = await http.post(
        `${API_URL}/api/v1/external/tags/all`,
        params
      );

      return response;
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  },
  async deleteExtTagGroup(context, tempId) {
    try {
      const response = await http.delete(
        `${API_URL}/api/v1/external/tags/${tempId}`
      );

      return response;
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  },
  async webhookMappingData(context, condition) {
    try {
      const response = await http.get(
        `${API_URL}/api/v1/external/tags/external-form-mapping?withWebhook=${condition}`
      );

      return response;
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  },
  async saveWebhookTemp(context, params) {
    try {
      const response = await http.post(
        `${API_URL}/api/v1/external/tags/`,
        params
      );

      return response;
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  },
  async searchExistingAlertExtTagGrpName(context,tagGrpName) {
    try {
      const response = await http.get(`${API_URL}/api/v1/external/tags/extTG/${tagGrpName}`);
      
      return response;
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  }
};

export default actions;
